/* twinelab theme scripts */

/* ---- review modal (from mockup) ---- */
function openReview(card){
  var m = document.getElementById('reviewModal');
  if(!m) return;
  var q = card && card.getAttribute('data-review');
  var n = card && card.getAttribute('data-reviewer');
  if(q){ var el=document.getElementById('rvQuote'); if(el) el.textContent = q; }
  if(n){ var el2=document.getElementById('rvName'); if(el2) el2.textContent = n; }
  m.classList.add('open');
}
function closeReview(){
  var m = document.getElementById('reviewModal');
  if(m) m.classList.remove('open');
}
document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeReview(); });

/* ---- product gallery thumb swap ---- */
document.addEventListener('click',function(e){
  var t = e.target;
  if(t && t.matches('.product-gallery .thumbs img')){
    var main = document.querySelector('.product-gallery .main img');
    if(main){ main.src = t.getAttribute('data-full') || t.src; }
  }
});

/* ---- product variant selection ---- */
(function(){
  var form = document.querySelector('[data-product-form]');
  if(!form) return;
  var variants = window.__twVariants || [];
  var priceEl = document.querySelector('[data-price]');
  var idInput = form.querySelector('input[name="id"]');
  var addBtn  = form.querySelector('.btn-add');

  function currentSelections(){
    var sels = {};
    form.querySelectorAll('input[type=radio]:checked').forEach(function(r){
      sels[r.name] = r.value;
    });
    return sels;
  }
  function money(cents){
    return '$' + (cents/100).toFixed(2).replace(/\.00$/,'');
  }
  function update(){
    var sels = currentSelections();
    var match = variants.find(function(v){
      return v.options.every(function(opt,i){
        return sels['option'+(i+1)] === undefined || sels['option'+(i+1)] === opt;
      });
    });
    if(match){
      if(idInput) idInput.value = match.id;
      if(priceEl) priceEl.textContent = money(match.price);
      if(addBtn){
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
    }
  }
  form.addEventListener('change', update);
  update();
})();
